export default {"src":"/_next/static/media/spin-small.fe64ddc1.svg","height":14,"width":14};